import { render } from "./popup-top-customer.vue?vue&type=template&id=75b2c0a6&ts=true"
import script from "./popup-top-customer.vue?vue&type=script&lang=ts"
export * from "./popup-top-customer.vue?vue&type=script&lang=ts"

import "./popup-top-customer.vue?vue&type=style&index=0&id=75b2c0a6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__